import { useRequiredContext } from "@redotech/react-util/context";
import ScalesIcon from "@redotech/redo-icons/scales-01.svg";
import ScalesFilledIcon from "@redotech/redo-icons/scales-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const AbTestItems = memo(function AbTestItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getConversionSubRoute("ab-tests") }}
      FilledIcon={ScalesFilledIcon}
      friendlyName="A/B tests"
      id="ab-tests"
      UnfilledIcon={ScalesIcon}
    />
  );
});
